import type { PlannerProject } from "../types";
import { moduleTopMm } from "./moduleRules";
import { isStackedModule } from "./layout";

export const STEP = 32;

export const clamp = (value: number, min: number, max: number) =>
  Math.max(min, Math.min(max, value));

export const snap = (value: number) => Math.round(value / STEP) * STEP;

export const createId = (prefix: string) => {
  const value =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID().slice(0, 8)
      : Math.random().toString(36).slice(2, 10);
  return `${prefix}-${value}`;
};

export const initialProject: PlannerProject = {
  name: "Новый проект",
  carcassMaterial: "matteWhite",
  room: {
    style: "light",
    wallColor: "#f7f5f0",
    floor: "light",
    lighting: "day",
    ceilingHeight: 3000
  },
  selectedModuleId: null,
  selectedItemId: null,
  selectedShelvingCellId: null,
  modules: []
};

export const totalWidth = (project: PlannerProject) =>
  project.modules
    .filter((module) => !isStackedModule(module))
    .reduce((sum, module) => sum + module.width, 0);

export const maxHeight = (project: PlannerProject) =>
  Math.max(...project.modules.map((module) => moduleTopMm(project, module)), 0);

export const maxDepth = (project: PlannerProject) =>
  Math.max(...project.modules.map((module) => module.depth), 0);
